import { useAuth } from './useAuth';

export function usePermission() {
  const { user } = useAuth();

  const hasPermission = (permission: string): boolean => {
    if (!user?.permissions) return false;
    return user.permissions.includes(permission);
  };

  const canView = (resource: string): boolean => hasPermission(`${resource}.view`);
  const canCreate = (resource: string): boolean => hasPermission(`${resource}.create`);
  const canUpdate = (resource: string): boolean => hasPermission(`${resource}.update`);
  const canDelete = (resource: string): boolean => hasPermission(`${resource}.delete`);

  return {
    hasPermission,
    canView,
    canCreate,
    canUpdate,
    canDelete,
    isAdmin: user?.roleCode === 'admin',
    isPromoter: user?.roleCode === 'promoter' || user?.roleCode === 'admin',
  };
}
